/* Tiroir de panier GLAMES.
   Le theme clone n'en avait pas : le formulaire postait vers /cart et
   rechargeait la page. On intercepte, on ajoute en AJAX, on ouvre le tiroir. */
(function () {
  var SEUIL_PORT = 6190;
  var RESERVE = 4 * 60;           // duree du panier reserve, en secondes

  var tiroir, minuteurId = null;
  var barres = {};                // handle -> { id de variante : prix barre }

  function chargerBarres(panier) {
    var aFaire = panier.items
      .map(function (a) { return a.handle; })
      .filter(function (h, i, t) { return h && t.indexOf(h) === i && !barres[h]; });
    if (!aFaire.length) return Promise.resolve();
    return Promise.all(aFaire.map(function (h) {
      return fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          barres[h] = {};
          p.variants.forEach(function (v) { if (v.compare_at_price) barres[h][v.id] = v.compare_at_price; });
        }).catch(function () {});
    }));
  }
  var q = function (s, r) { return (r || document).querySelector(s); };
  var qq = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var euro = function (c) { return '€' + (c / 100).toFixed(2).replace('.', ','); };
  var texte = function (s) {
    var d = document.createElement('div'); d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  };
  var deshtml = function (s) {
    var d = document.createElement('textarea'); d.innerHTML = s || ''; return d.value;
  };

  /* ---------- rendu ---------- */

  var cacheDispo = {};
  // Retire du panier les articles devenus indisponibles, avant que le client n'arrive au paiement.
  function nettoyerIndisponibles(panier) {
    var aVerifier = (panier.items || []).filter(function (a) { return a.handle; });
    if (!aVerifier.length) return Promise.resolve(panier);
    return Promise.all(aVerifier.map(function (a) {
      if (cacheDispo[a.handle] !== undefined) return Promise.resolve({ a: a, p: cacheDispo[a.handle] });
      return fetch('/products/' + a.handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { cacheDispo[a.handle] = p; return { a: a, p: p }; })
        .catch(function () { return { a: a, p: null }; });
    })).then(function (res) {
      var aRetirer = res.filter(function (x) {
        if (!x.p) return false;
        var v = (x.p.variants || []).filter(function (vv) { return vv.id === x.a.variant_id; })[0];
        return v && v.available === false;
      });
      if (!aRetirer.length) return panier;
      return aRetirer.reduce(function (chaine, x) {
        return chaine.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: String(x.a.key), quantity: 0 })
          }).then(function (r) { return r.json(); });
        });
      }, Promise.resolve()).then(function (dernier) { return dernier || panier; });
    });
  }

  function rendre(panier) {
    if (!tiroir) return;
    var vide = panier.item_count === 0;
    q('[data-hs-nb]', tiroir).textContent =
      panier.item_count + ' ' + (panier.item_count > 1 ? 'items' : 'item');
    q('[data-hs-vide]', tiroir).hidden = !vide;
    q('[data-hs-pied]', tiroir).hidden = vide;
    q('[data-hs-minuteur]', tiroir).hidden = vide;
    q('[data-hs-port]', tiroir).style.display = vide ? 'none' : '';

    var liste = q('[data-hs-lignes]', tiroir);
    liste.innerHTML = panier.items.map(function (a, i) {
      var opts = (a.options_with_values || [])
        .filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return texte(o.name) + ' : ' + texte(o.value); }).join(' · ');
      var barre = a.original_line_price > a.final_line_price
        ? '<s>' + euro(a.original_line_price) + '</s>' : '';
      return '<li class="hs-ligne" data-cle="' + texte(a.key) + '" data-rang="' + (i + 1) + '">' +
        (a.image ? '<img class="hs-ligne__img" src="' + texte(a.image + (a.image.indexOf('?') > -1 ? '&' : '?') + 'width=220') + '" alt="" width="75" height="75" loading="lazy">' : '<span class="hs-ligne__img"></span>') +
        '<div><a class="hs-ligne__titre" href="' + texte(a.url) + '">' + texte(deshtml(a.product_title)) + '</a>' +
        (opts ? '<p class="hs-ligne__opt">' + opts + '</p>' : '') +
        (a.final_line_price === 0 ? '<div class="hs-ligne__bas"><span class="hs-ligne__cadeau">🎁 Free gift</span><span class="hs-ligne__prix">' + euro(0) + '</span></div></div></li>' : '') +
        (a.final_line_price === 0 ? '' : '<div class="hs-ligne__bas"><span class="hs-qte">' +
          '<button type="button" data-hs-moins aria-label="Decrease quantity">−</button>' +
          '<span>' + a.quantity + '</span>' +
          '<button type="button" data-hs-plus aria-label="Increase quantity">+</button>' +
        '</span><span class="hs-ligne__prix">' + barre + euro(a.final_line_price) + '</span></div>' +
        '<button type="button" class="hs-ligne__retirer" data-hs-retirer>Remove</button></div></li>');
    }).join('');

    var eco = panier.original_total_price - panier.total_price;
    // les prix barres ne sont pas dans /cart.js : on les lit sur les produits
    panier.items.forEach(function (a) {
      var ref = barres[a.handle] && barres[a.handle][a.variant_id];
      if (ref && ref > a.price) eco += (ref - a.price) * a.quantity;
    });
    var blocEco = q('[data-hs-economie]', tiroir);
    blocEco.style.display = eco > 0 ? 'flex' : 'none';
    if (eco > 0) q('[data-hs-economie-val]', tiroir).textContent = '− ' + euro(eco);
    q('[data-hs-total]', tiroir).textContent = euro(panier.total_price);

    var manque = SEUIL_PORT - panier.total_price;
    var t = q('[data-hs-port-texte]', tiroir);
    if (manque > 0) {
      t.innerHTML = 'Only <b>' + euro(manque) + '</b> away from free shipping';
      q('[data-hs-jauge]', tiroir).style.width =
        Math.max(4, Math.round(panier.total_price / SEUIL_PORT * 100)) + '%';
    } else {
      t.innerHTML = "<b>You've unlocked free shipping!</b>";
      q('[data-hs-jauge]', tiroir).style.width = '100%';
    }

    var sup = q('[data-hs-sup]', tiroir);
    if (sup) {
      var dedans = panier.items.some(function (a) { return String(a.variant_id) === sup.dataset.id; });
      q('.hs-bascule', sup).setAttribute('aria-checked', dedans ? 'true' : 'false');
    }
    qq('[data-hs-bulle]').forEach(function (b) { b.textContent = panier.item_count; });
  }

  function rafraichir() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { return chargerBarres(p).then(function () { rendre(p); return p; }); });
  }

  /* ---------- ouverture / fermeture ---------- */

  function ouvrir() {
    if (!tiroir) return;
    rafraichir();          // le panier a pu changer depuis le chargement de la page
    tiroir.hidden = false;
    tiroir.setAttribute('aria-hidden', 'false');
    // requestAnimationFrame ne se declenche pas dans un onglet masque :
    // on garde un repli sur setTimeout pour que l'ouverture aboutisse toujours.
    var montrer = function () { tiroir.classList.add('est-ouvert'); };
    requestAnimationFrame(montrer);
    setTimeout(montrer, 30);
    var y = window.scrollY || 0; document.documentElement.style.setProperty('--hs-defil', (-y) + 'px'); document.documentElement.classList.add('hs-tiroir-ouvert'); document.body.classList.add('hs-tiroir-ouvert'); document.body.dataset.hsDefil = String(y);
    lancerMinuteur();
  }
  function fermer() {
    if (!tiroir) return;
    tiroir.classList.remove('est-ouvert');
    tiroir.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('hs-tiroir-ouvert'); document.body.classList.remove('hs-tiroir-ouvert'); window.scrollTo(0, parseInt(document.body.dataset.hsDefil || '0', 10));
    setTimeout(function () { if (!tiroir.classList.contains('est-ouvert')) tiroir.hidden = true; }, 320);
  }

  function lancerMinuteur() {
    var champ = q('[data-hs-chrono]', tiroir);
    if (!champ || minuteurId) return;
    var fin;
    try { fin = parseInt(sessionStorage.getItem('hs-reserve'), 10) || 0; } catch (e) { fin = 0; }
    var maintenant = Math.floor(performance.timeOrigin ? (performance.timeOrigin + performance.now()) / 1000 : 0);
    if (!fin || fin <= maintenant) {
      fin = maintenant + RESERVE;
      try { sessionStorage.setItem('hs-reserve', String(fin)); } catch (e) {}
    }
    minuteurId = setInterval(function () {
      var t = Math.floor(performance.timeOrigin ? (performance.timeOrigin + performance.now()) / 1000 : 0);
      var reste = Math.max(0, fin - t);
      champ.textContent = String(Math.floor(reste / 60)).padStart(2, '0') + ':' + String(reste % 60).padStart(2, '0');
      if (reste === 0) { clearInterval(minuteurId); minuteurId = null; }
    }, 1000);
  }

  /* ---------- actions ---------- */

  function changer(rang, qte) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(rang), quantity: qte })
    }).then(function (r) { return r.json(); })
      .then(function (p) { return nettoyerIndisponibles(p).then(function (p2) { chargerBarres(p2).then(function () { rendre(p2); }); }); });
  }

  function ajouter(id, qte, formulaire) {
    var req = formulaire
      ? { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(formulaire) }   // le formulaire entier : offres groupees, proprietes
      : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qte || 1 }] }) };
    return fetch('/cart/add.js', req).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message); });
      return r.json();
    }).then(function () { return rafraichir(); });
  }

  function brancher() {
    tiroir = q('#hs-tiroir');
    if (!tiroir) return;

    qq('[data-hs-fermer]', tiroir).forEach(function (b) { b.addEventListener('click', fermer); });
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && tiroir.classList.contains('est-ouvert')) fermer();
    });

    tiroir.addEventListener('click', function (e) {
      var ligne = e.target.closest('.hs-ligne');
      if (ligne) {
        var rang = ligne.dataset.rang;
        var qte = parseInt(q('.hs-qte span', ligne).textContent, 10) || 1;
        if (e.target.closest('[data-hs-plus]')) return changer(rang, qte + 1);
        if (e.target.closest('[data-hs-moins]')) return changer(rang, Math.max(0, qte - 1));
        if (e.target.closest('[data-hs-retirer]')) return changer(rang, 0);
      }
      var bascule = e.target.closest('.hs-bascule');
      if (bascule) {
        var sup = bascule.closest('[data-hs-sup]');
        var actif = bascule.getAttribute('aria-checked') === 'true';
        bascule.setAttribute('aria-checked', actif ? 'false' : 'true');
        if (actif) {
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (p) {
            var i = p.items.findIndex(function (a) { return String(a.variant_id) === sup.dataset.id; });
            return i >= 0 ? changer(String(i + 1), 0) : rafraichir();
          });
        }
        return ajouter(sup.dataset.id, 1).then(ouvrir);
      }
    });

    // le bouton d'ajout ouvre le tiroir au lieu de recharger la page
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || f.tagName !== 'FORM') return;
      var action = f.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      var champ = f.querySelector('[name="id"]');
      if (!champ || !champ.value) return;
      // la fiche d'appel a son propre script d'offre groupee (cadeaux) qui ajoute lui-meme :
      // on le laisse faire et on ouvre le tiroir une fois le panier a jour.
      if (f.querySelector('.pob-atc--enhanced') || (f.closest('product-form') || {}).hasAttribute && f.closest('product-form').hasAttribute('data-options')) {
        setTimeout(function () { rafraichir().then(ouvrir); }, 1600);
        return;
      }
      e.preventDefault(); e.stopPropagation();
      var bouton = f.querySelector('button[name="add"], .product-form__submit');
      if (bouton) bouton.classList.add('hs-charge');
      var qte = parseInt((f.querySelector('[name="quantity"]') || {}).value, 10) || 1;
      ajouter(champ.value, qte, f)
        .then(ouvrir)
        .catch(function (err) {
          console.error(err);
          f.submit();   // repli : on laisse le navigateur poster le formulaire
        })
        .then(function () { if (bouton) bouton.classList.remove('hs-charge'); });
    }, true);

    // l'icone panier de l'entete ouvre le tiroir
    qq('a[href]').filter(function (a) {
      var h = a.getAttribute('href') || '';
      return /^(https?:\/\/[^\/]+)?\/cart\/?($|\?)/.test(h);
    }).forEach(function (a) {
      if (a.closest('#hs-tiroir')) return;
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault(); e.stopPropagation(); ouvrir();
      }, true);
    });
    qq('#cart-icon-bubble, .header__icon--cart, [data-cart-icon]').forEach(function (b) {
      if (b.tagName === 'A') return;
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); ouvrir(); }, true);
    });

    // Les scripts du theme (offre groupee, ajout rapide) ouvrent le tiroir Dawn sans passer par un submit :
    // quand ce tiroir-la veut s'ouvrir, c'est le notre qui s'ouvre.
    var dawn = document.querySelector('cart-drawer');
    if (dawn && window.MutationObserver) {
      new MutationObserver(function () {
        if (dawn.classList.contains('active') || dawn.classList.contains('is-open')) {
          dawn.classList.remove('active'); dawn.classList.remove('is-open');
          rafraichir().then(ouvrir);
        }
      }).observe(dawn, { attributes: true, attributeFilter: ['class'] });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.pob-atc--enhanced')) setTimeout(function () { rafraichir().then(ouvrir); }, 1800);
    }, true);
    rafraichir();
    window.hsTiroirPanier = { ouvrir: ouvrir, fermer: fermer, rafraichir: rafraichir };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancher);
  else brancher();
})();
